import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';

import {DjelatnikComponent} from './djelatnik.component.js';
import FormComponent from './form/form.js';

const djelatnik = angular.module('djelatnik', [uiModal]);

djelatnik.component('djelatnik', DjelatnikComponent);
djelatnik.component('djelatnikForm', FormComponent);

export {djelatnik};



// WEBPACK FOOTER //
// ./app/components/djelatnik/djelatnik.js